<div class="card step-card flex flex-column">
  <form [formGroup]="deviceForm" *ngIf="deviceForm">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="serialNumber">{{'attribute.serialNumber' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="serialNumber" type="text" formControlName="serialNumber" class="w-full">
        </div>
        <app-validation-errors [control]="deviceForm.get('serialNumber')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="alias">{{'attribute.alias' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="alias" type="text" formControlName="alias" class="w-full">
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="timezone">{{'attribute.timezone' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.timezone' | transloco"
            [options]="timezones"
            [filter]="true"
            styleClass="w-full"
            id="timezone"
            optionValue="name"
            optionLabel="name"
            formControlName="timezone"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="onTenantChange($event)"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="organization">{{'model.organization' | transloco}} (*)</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.organization' | transloco"
            [options]="organizations"
            [filter]="true"
            (onChange)="onOrganizationChange($event)"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            formControlName="organization"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="category">{{'model.category' | transloco}} (*)</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.category' | transloco"
            [options]="deviceCategories"
            [filter]="true"
            (onChange)="onDeviceCategoryChange($event)"
            styleClass="w-full"
            id="category"
            optionLabel="name"
            formControlName="deviceCategory"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="template">{{'model.template' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [(ngModel)]="template"
            [ngModelOptions]="{standalone: true}"
            [placeholder]="'select.template' | transloco"
            [options]="templates"
            [filter]="true"
            [disabled]="templateDisabled"
            [showClear]="true"
            (onChange)="onChangeTemplate($event)"
            styleClass="w-full"
            id="template"
            optionLabel="name"
          ></p-dropdown>
        </div>
      </div>
      <div *ngIf="'ROLE_SUPER_ADMIN' | userHasRole" class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="defaultDevice">{{'model.defaultDeviceCatalog' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [(ngModel)]="defaultDevice"
            [ngModelOptions]="{standalone: true}"
            [placeholder]="'select.defaultDevice' | transloco"
            [options]="defaultDevices"
            [filter]="true"
            [disabled]="defaultDeviceDisabled"
            [showClear]="true"
            (onChange)="onChangeDefaultDevice($event)"
            styleClass="w-full"
            id="defaultDevice"
            optionLabel="name"
          >
            <ng-template let-defaultDevice pTemplate="item">{{defaultDevice.name}} (v{{defaultDevice.version}})</ng-template>
            <ng-template let-defaultDevice pTemplate="selectedItem">{{defaultDevice.name}} (v{{defaultDevice.version}})</ng-template>
          </p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="form-field col-12 pb-0 flex align-items-center">
          <label class="cursor-pointer" (click)="technicalDetailsVisible = !technicalDetailsVisible">
            {{'attribute.technicalDetails' | transloco}}
          </label>
          <button
            [icon]="technicalDetailsVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
            (click)="technicalDetailsVisible = !technicalDetailsVisible"
            pButton
            pRipple
            class="p-button-sm p-button-secondary p-button-text" type="button"
          ></button>
        </div>
        <div class="col-12 p-3">
          <json-editor
            #technicalDetailsEditor
            [options]="(('ROLE_ADMIN' | userHasRole) ? jsonEditorService.buildFormEditorOptions() : jsonEditorService.buildReadonlyEditorOptions())"
            [hidden]="!technicalDetailsVisible"
            formControlName="technicalDetails"
          ></json-editor>
        </div>
      </div>
    </div>
  </form>

  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.next' | transloco"
          [disabled]="!deviceForm?.valid || !organizationSelected"
          (click)="onNextStep()"
          pButton
          pRipple
          class="flex-1"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>

</div>
